import { FunctionsHttpError } from '@supabase/supabase-js';

import { extractFunctionError } from '@/lib/functions';
import { supabase } from '@/lib/supabase';

export type AcceptanceResult =
  | { kind: 'free' }
  | { kind: 'wallet' }
  | { kind: 'insufficientInk' };

/**
 * «Συμφωνώ»: το τέλος 1€ καλύπτεται από δωρεάν υπόλοιπο ή από το πορτοφόλι
 * μελανιού (φορτίζεται αποκλειστικά μέσω Google Play, βλ. wallet/topup.tsx).
 * Αν δεν επαρκεί κανένα από τα δύο, το backend επιστρέφει 402 και ο καλών
 * πρέπει να στείλει τον χρήστη να κάνει top-up — καμία εναλλακτική πληρωμή.
 */
export async function startAgreementAcceptance(agreementId: string): Promise<AcceptanceResult> {
  const { data, error } = await supabase.functions.invoke<{
    free?: boolean;
    paidFromWallet?: boolean;
    requiresTopUp?: boolean;
  }>('agree-to-agreement', { body: { agreementId } });

  if (error) {
    if (error instanceof FunctionsHttpError && error.context.status === 402) {
      return { kind: 'insufficientInk' };
    }
    throw new Error(await extractFunctionError(error, 'Η αποδοχή απέτυχε.'));
  }

  if (data?.free) return { kind: 'free' };
  if (data?.paidFromWallet) return { kind: 'wallet' };

  throw new Error('Απρόσμενη απάντηση από τον server.');
}
